import type { MatchingColumnProps } from '.';

import { QuestionMatchingAnswer } from '.';

export function MatchingColumn(matchingColumnProps: MatchingColumnProps) {
  const { answers, selectedAnswerId, column, isAnswerUsed, onAnswerClick, getPairNumber, getMarkedState } = matchingColumnProps;

  const pairColors: string[] = [
    'bg-[var(--color-brand-200)]/30 hover:bg-[var(--color-brand-200)]/50 border-[var(--color-brand-200)]', // light brand]
    'bg-[var(--color-orange-400)]/30 hover:bg-[var(--color-orange-400)]/50 border-[var(--color-orange-400)]', // light orange
    'bg-[var(--color-blue-300)]/30 hover:bg-[var(--color-blue-300)]/50 border-[var(--color-blue-300)]', // light blue
    'bg-[var(--color-turquoise-300)]/30 hover:bg-[var(--color-turquoise-300)]/50 border-[var(--color-turquoise-300)]', // light turquoise
    'bg-[var(--color-purple-300)]/30 hover:bg-[var(--color-purple-300)]/50 border-[var(--color-purple-300)]', // light purple
    'bg-[var(--color-brand-700)]/30 hover:bg-[var(--color-brand-700)]/50 border-[var(--color-brand-700)]', // dark brand
    'bg-[var(--color-blue-700)]/30 hover:bg-[var(--color-blue-700)]/50 border-[var(--color-blue-700)]', // dark blue
    'bg-[var(--color-turquoise-700)]/30 hover:bg-[var(--color-turquoise-700)]/50 border-[var(--color-turquoise-700)]', // dark turquoise
    'bg-[var(--color-purple-700)]/30 hover:bg-[var(--color-purple-700)]/50 border-[var(--color-purple-700)]', // dark purple
    'bg-[var(--color-orange-700)]/30 hover:bg-[var(--color-orange-700)]/50 border-[var(--color-orange-700)]', // dark orange
  ];
  return (
    <div className="grid auto-rows-auto grid-cols-1 gap-3">
      {answers.map((answer) => {
        const pairNumber: number | null = getPairNumber(answer.id, column);
        const pairBgColor: string | undefined = pairNumber ? pairColors[(Number(pairNumber) - 1) % pairColors.length] : '';
        return (
          <QuestionMatchingAnswer
            key={answer.id}
            content={answer.content}
            correct={getMarkedState(answer)}
            isSelected={selectedAnswerId === answer.id}
            pairNumber={pairNumber}
            isDisabled={isAnswerUsed(answer.id, column)}
            onClick={() => onAnswerClick(answer.id)}
            className={pairBgColor}
          />
        );
      })}
    </div>
  );
}
